"use client";
import { cn } from "@/lib/library";
import { OrderStatus } from "@/lib/orders/order-types";

export default function OrderStatusBadge({ orderStatus }: { orderStatus: OrderStatus }) {
    const statusStyles: Record<OrderStatus, string> = {
        Submitted: "bg-lime-400",
        Accepted: "bg-green-400",
        "On the Way": "bg-teal-400",
        Delivered: "bg-gray-200",
        Error: "bg-yellow-400"
    };
    return (
        <div
            className={cn(
                "inline-block h-fit w-fit whitespace-nowrap rounded-sm border bg-opacity-75 px-1 py-0.5 text-sm",
                statusStyles[orderStatus]
            )}
        >
            {orderStatus}
        </div>
    );
}
